export const STATE_NAME = 'ALLOCATION';

export const PREFIX = `${STATE_NAME}_`;

export const UPDATE_FILTERS = PREFIX + 'UPDATE_FILTERS';
